let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1yrlK")).then(() => parcelRequire('2LFoe'));